import { memoize } from 'lodash';
import React from 'react';
import styled from 'styled-components';
import { EmptyCell } from 'components/atoms/empty-cell';
import { Rate } from 'components/atoms/rate';

const Flex = styled.div`
  display: flex;
  align-items: center;
`;

export const csatRender = memoize((csatValue: number) => {
  if (csatValue) {
    return (
      <Flex>
        <Rate count={1} defaultValue={1} disabled />
        <span className="ant-rate-text">{csatValue}</span>
      </Flex>
    );
  }

  return <EmptyCell />;
});
